import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserSettingsContext } from '../context/UserSettingsContext';
import { isEmulating, getOriginalUserSettings } from '../utils/emulation';
import PageSkeleton from './PageSkeleton';

/**
 * Admin gate. Admin routes sit inside ProtectedRoute (sign-in + settings
 * already resolved), so this decides synchronously from the loaded settings
 * — no Cognito round-trip or full-window skeleton on every visit to /admin.
 */
function AdminProtectedRoute({ children }) {
  const { userSettings } = useUserSettingsContext();
  const location = useLocation();

  // When emulating, access control follows the original admin's settings.
  const originalSettings = isEmulating() ? getOriginalUserSettings() : null;
  const settings = originalSettings || userSettings;

  if (!settings) return <PageSkeleton message="Loading" />;

  if (settings.isAdmin !== 1) {
    // From a Help guide or the assistant: say why instead of silently redirecting.
    if (location.state?.fromHelp) {
      return <Navigate to={`/no-access?to=${encodeURIComponent(location.pathname + location.search)}`} replace state={{ fromHelp: true }} />;
    }
    // Redirect to dashboard if authenticated but not an admin
    return <Navigate to="/dashboard" replace />;
  }

  // If authenticated and admin, render the children or Outlet for nested routes
  return children ? children : <Outlet />;
}

export default AdminProtectedRoute;
